<!--
  Active emergency (REQ-88): one banner per event MSDH has open in BPWS, at the
  top of the home page, leading to the Emergency Notice form. It cannot be
  dismissed; it goes away when BPWS closes the event. Styled after the BPWS
  home page banner.
-->
<template>
  <div v-if="events.length">
    <div v-for="e in events" :key="e.id" class="emergency-banner mb-3"
         role="button" tabindex="0" @click="open" @keyup.enter="open">
      <b-icon icon="exclamation-triangle-fill" font-scale="1.8" class="banner-icon" />
      <div class="banner-text">
        <div class="banner-title">{{ e.name }}</div>
        <div class="banner-sub">
          Report outages, pressure loss, a boil water notice or a need for help:
          file an Emergency Notice.
        </div>
      </div>
      <b-icon icon="chevron-right" font-scale="1.3" class="banner-chevron" />
    </div>
  </div>
</template>

<script>
export default {
  name: "EmergencyBanner",
  props: {
    signed_in: { type: Boolean, default: false },
  },
  data() {
    return { events: [] }
  },
  created() {
    this.fetchEvents()
  },
  methods: {
    async fetchEvents() {
      try {
        const res = await this.axios.get(process.env.VUE_APP_API_URI + "/emergency-events")
        this.events = (res.data && res.data.events) || []
      } catch (error) {
        // No banner is the safe failure: the form is still on the home page.
        console.log('EmergencyBanner: could not load events', error)
      }
    },
    open() {
      // The form needs a signed-in system: the same "Sign In Required" prompt
      // as the home page tiles (the modal lives in HomeClassic/HomeModern).
      if (this.signed_in) this.$router.push('emergency')
      else this.$bvModal.show('sign-in-modal')
    },
  },
}
</script>

<style scoped>
.emergency-banner {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border-radius: 10px;
  color: #fff;
  background: linear-gradient(90deg, #b71c1c, #e53935);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}
.emergency-banner:hover,
.emergency-banner:focus {
  filter: brightness(1.06);
  outline: none;
}
.banner-icon {
  flex: none;
  opacity: 0.85;
}
.banner-text {
  flex: 1;
  min-width: 0;
}
.banner-title {
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.3;
}
.banner-sub {
  font-size: 0.9rem;
  opacity: 0.95;
}
.banner-chevron {
  flex: none;
}
</style>
